import { Observable } from "rxjs";

import { EventSourceOptions } from "../server-sent-events/sse.client";

export abstract class Streamer {
  abstract stream<T>(url: string, options: EventSourceOptions): Observable<T>;
  abstract disconnect(): void;
}
